module.exports = __webpack_public_path__ + "static/media/ag-staffLR.b97ee605.jpg";